import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = null;

const syncReducers = {
  setOrder: (state, { payload }) => {
    return payload;
  },
  updateOrder: (state, { payload }) => {
    return { ...state, ...payload };
  },
  clearOrder: () => {
    return INITIAL_STATE;
  },
};

const order = createSlice({
  name: "order",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setOrder, updateOrder, clearOrder } = order.actions;

export default order.reducer;
